import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MenuFunctionalityEnum } from 'src/app/shared/menu/menu.functionality.enum';
import { MenuModuleEnum } from 'src/app/shared/menu/menu.module.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { IntegrationLogService } from 'src/app/shared/services/API/integration/integration-log.service';
import { LookupService } from 'src/app/shared/services/API/integration/lookup.service';
import { LogTypeModel } from 'src/app/shared/services/models/integration/log-type.model';
import { UriModel } from 'src/app/shared/services/models/integration/uri.model';
import { IntegrationLogStruct } from 'src/app/shared/services/structs/integration/integration-log.struct';
import { LogDetailsModalComponent } from 'src/app/shared/components/log-details-modal/log-details-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { TableComponent } from 'src/app/shared/components/table/table.component';

@Component({
  selector: 'app-log-integration',
  templateUrl: './log-integration.component.html',
  styleUrls: ['./log-integration.component.css']
})
export class LogIntegrationComponent implements OnInit {
  constructor(private alertService: AlertService,
    private integrationLogService: IntegrationLogService,
    private lookupService: LookupService,
    public dialog: MatDialog,
  ) { }
  
  @ViewChild(MatPaginator) paginator: MatPaginator;

  menuModuleEnum: MenuModuleEnum = MenuModuleEnum.developer;
  menuFunctionalityEnum: MenuFunctionalityEnum = MenuFunctionalityEnum.log_batch_list;

  isLoading: boolean = true;

  fullListSize: number = 0;

  listUri: UriModel[] = [];
  listLogType: LogTypeModel[] = [];
  listIdHealthUnit: number[] = [];
  listIntegrationLogStruct: IntegrationLogStruct[] = [];
  listLog: any[] = [];

  idUri: number = null;
  idLogType: number = null;
  idHealthUnit: number = null;

  searchText: string = null;
  selectedPeriod: Date = null;

  columns: { header: string, field: string, isAction?: boolean, width?: string }[] = [
    { header: 'Uri', field: 'uriName', width: '6%' },
    { header: 'ID Unidade de Saúde', field: 'idHealthUnit', width: '6%' },
    { header: 'Log Solicitante', field: 'jsonRequest', width: '10%' },
    { header: 'Log Resposta', field: 'jsonResponse', width: '10%' },
    { header: 'Ip Solicitante', field: 'ipRequest', width: '5%' },
    { header: 'ID Episódio', field: 'idEpisode', width: '7%' },
    { header: 'Data da Solicitação', field: 'datetimeInclusion', width: '5%' },
    { header: 'Ações', field: 'actions', isAction: true, width: '2%' }
  ];

  ngOnInit(): void {
    this.getLookup();
    this.search(0);
  }

  changePage(event: PageEvent) {
    this.search(event.pageIndex);
  }

  private timeoutKeySearch: any = null;

  onKeySearch(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13)
        $this.search(0);
    }, 1000);
  }

  cancel() {
    this.searchText = null;
    this.idLogType = null;
    this.idUri = null;
    this.selectedPeriod = null;
    this.idHealthUnit = null;
    this.search(0);
  }

  search(pageIndex: number) {
    this.isLoading = true;
    this.listLog = null;

    if (this.selectedPeriod instanceof Date)
      this.selectedPeriod.setHours(0, 0, 0, 0);

    this.integrationLogService.search(this.idUri, this.idLogType, this.selectedPeriod, pageIndex, this.searchText, this.idHealthUnit).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        if (response?.paginatedIntegrationLog.length > 0) {
          this.listIdHealthUnit = response.listIdHealthUnit;

          this.fullListSize = response.fullListSize;
          this.listLog = this.transformToTableRows(response.paginatedIntegrationLog);
        }
        else {
          this.listIntegrationLogStruct = null;
          this.listLog = null;
          if (!this.idHealthUnit)
            this.listIdHealthUnit = null;
          this.fullListSize = 0;
        }

        this.isLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this.isLoading = false;
      }
    });
  }

  getLookup() {
    this.lookupService.getLookup().subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.listLogType = response.listLogType;
        this.listUri = response.listUri;
      },
      error: (error) => {
        console.log(error);
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this.isLoading = false;
      }
    });
  }

  logDetails(event: any) {
    let numberOfLinesInTextPatientExitLog = this.countLinesInArea(event.jsonRequest, 825, 16);
    const dialogRef = this.dialog.open(LogDetailsModalComponent, {
      panelClass: 'custom-dialog-class',
      height: '90vh',
      disableClose: true,
      data: {
        logRequestDetails: event.jsonRequest,
        logResponseDetails: event.jsonResponse,
        numberOfLinesInTextPatientExitLog
      }
    });
    dialogRef.afterClosed().subscribe({
      next: result => {
      }
    });
  }

  countLinesInArea(text: string, areaWidth: number, fontSize: number): number {
    if (!text || text.trim() === "")
      return 0;

    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (!context) return 0;

    context.font = `${fontSize}px Arial`;

    const words = text.split(' ');
    let lineWidth = 0;
    let lines = 1;

    for (const word of words) {
      const wordWidth = context.measureText(word + ' ').width;
      if (lineWidth + wordWidth > areaWidth) {
        lines++;
        lineWidth = wordWidth; // Começa uma nova linha
      }
      else
        lineWidth += wordWidth;
    }

    return lines;
  }

  transformToTableRows(listLog: IntegrationLogStruct[]) {
    return listLog.map(log => {
      const handleInvalidJson = (jsonString: string): any => {
        if (jsonString.startsWith("INVALID_JSON: "))
          return jsonString.replace("INVALID_JSON: ", ""); // Remove a marcação e exibe como string

        try {
          return JSON.parse(jsonString);
        }
        catch {
          return jsonString; // Se ainda assim der erro, exibe como string
        }
      };

      let logRequest = handleInvalidJson(log.jsonRequest || "{}");
      let formattedLogData = this.beautify(logRequest);

      let logResponse = handleInvalidJson(log.jsonResponse || "{}");
      let formattedLogResponseData = this.beautify(logResponse);

      return {
        uriName: this.listUri?.find(x => x.idUri == log.idUri)?.description,
        datetimeInclusion: log.datetimeBeginRequest,
        idHealthUnit: log.idHealthUnit,
        jsonRequest: formattedLogData,
        jsonResponse: formattedLogResponseData,
        idEpisode: log.idEpisode,
        ipRequest: log.ipRequest
      };
    });
  }

  beautify(json: any): string {
    return typeof json === "string" ? json : JSON.stringify(json, null, 2);
  }
}